import { ConfigProvider, Image } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import logo from 'assets/icons/login-cover.png';

import './index.scss';

// Shared shell for the client sign-in and verification screens. Mirrors the
// admin authentication pages: navy brand panel beside the form, RTL first.
const AuthLayout = ({ title, subtitle, children }) => {
  const { t } = useTranslation('auth-layout');

  return (
    <ConfigProvider direction="rtl">
      <div className="auth-layout" dir="rtl" lang="ar">
        <aside className="auth-layout__aside">
          <div className="auth-layout__aside-inner">
            <span className="auth-layout__mark">{t('brand')}</span>
            <h2>{t('panel-title')}</h2>
            <p>{t('panel-subtitle')}</p>
            <ul className="auth-layout__points">
              <li>{t('point-catalog')}</li>
              <li>{t('point-prices')}</li>
              <li>{t('point-orders')}</li>
            </ul>
          </div>
        </aside>

        <main className="auth-layout__main">
          <div className="auth-layout__card">
            <div className="auth-layout__brand">
              <Image src={logo} preview={false} alt={t('brand')} />
            </div>
            <h1 className="auth-layout__title">{title}</h1>
            {subtitle && <p className="auth-layout__subtitle">{subtitle}</p>}
            {children}
          </div>
          <p className="auth-layout__legal">{t('legal')}</p>
        </main>
      </div>
    </ConfigProvider>
  );
};

AuthLayout.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node,
};

export default AuthLayout;
